/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
import sumTableValue from '../../../../../components/Table/Utils/sumTableValue';
import {
  calculatePercentage,
  roundToDecimal
} from '../../../../netZero/constants/commonFunctions';
import {dataIdsOfTotalLOA, scopeMetrics} from '../constants/commonConstants';

import {allCharts, generalizedLOA} from './commonConstants';

interface valueKey {
  [key: string]: {dataId: string; scope: number};
}

export const groupByDataId = (obj: valueKey, array: any[]): any => {
  return Object.entries(obj).map((item: any) => {
    const [, {dataId, scope}] = item;
    const allArray = array?.filter((a) => {
      return a?.dataId === dataId;
    });

    return {
      dataId: dataId,
      array: allArray ?? [],
      value: roundToDecimal(
        sumTableValue(allArray, 'yearlyEmission', false) as number
      ),
      scope
    };
  });
};

export const asPerScope: (group: any[]) => {
  scope1: any[];
  scope2: any[];
  scope3: any[];
} = (group: any[]) => {
  const scope1: any[] = [];
  const scope2: any[] = [];
  const scope3: any[] = [];

  group.forEach((item: any) => {
    if (item.scope === 1) {
      scope1.push(item);
    }
    if (item.scope === 2) {
      scope2.push(item);
    }
    if (item.scope === 3) {
      scope3.push(item);
    }
  });

  return {
    scope1,
    scope2,
    scope3
  };
};

export const formatListOfActivity: (
  array: any[],
  blockScope3?: boolean
) => {
  allChart: any[];
  GHG: any[];
  SCOPE: any[];
} = (array: any[], blockScope3 = true) => {
  const showAsPerSubscriptionLOA = blockScope3
    ? Object.fromEntries(
        Object.entries(dataIdsOfTotalLOA).filter(([, v]) => v.scope !== 3)
      )
    : dataIdsOfTotalLOA;

  const showChartDataAsPerSubscription = (data: any[]) => {
    return blockScope3
      ? data.filter((item: any) => {
          return item.scope !== 3;
        })
      : data;
  };

  const groupedValue: any[] = groupByDataId(showAsPerSubscriptionLOA, array);

  const {scope1, scope2, scope3} = asPerScope(groupedValue);

  const allChart = allCharts.map((items: any) => {
    const data = showChartDataAsPerSubscription(items?.data)?.map(
      (item: any) => {
        const keyDataIds =
          item?.key?.map((keyItem: any) => keyItem?.dataId) || [];

        const totalValue = Number(
          groupedValue
            ?.filter((gItem: any) => {
              return keyDataIds.includes(gItem?.dataId);
            })
            ?.reduce((sum: number, gItem: any) => sum + (gItem?.value || 0), 0)
            .toFixed(2)
        );

        return {
          ...item,
          value: totalValue
        };
      }
    );

    return {
      ...items,
      data
    };
  });

  const allScopes = [...scope1, ...scope2, ...scope3];

  const allScopeTotal = sumTableValue(allScopes, 'value', false) as number;

  const generalizedLOAAsPerSubscription = blockScope3
    ? generalizedLOA.filter((item: any) => {
        return item?.dataId !== 'Scope 3 GHG emissions';
      })
    : generalizedLOA;

  const GHG = generalizedLOAAsPerSubscription.map((item: any) => {
    const mainValue =
      item?.dataId === 'Total GHG Emissions'
        ? roundToDecimal(sumTableValue(allScopes, 'value', false) as number)
        : item?.dataId === 'Scope 1 GHG emissions'
          ? roundToDecimal(sumTableValue(scope1, 'value', false) as number)
          : item?.dataId === 'Scope 2 GHG emissions'
            ? roundToDecimal(sumTableValue(scope2, 'value', false) as number)
            : roundToDecimal(sumTableValue(scope3, 'value', false) as number);

    return {
      ...item,
      value: mainValue,
      percentage: calculatePercentage(mainValue, allScopeTotal) ?? 0
    };
  });

  const SCOPE = scopeMetrics.map((item) => {
    const data = item?.data.map((dataItem: any) => {
      const keyDataIds =
        dataItem?.key?.map((keyItem: any) => keyItem?.dataId) || [];

      const totalValue = Number(
        groupedValue
          ?.filter((gItem: any) => keyDataIds.includes(gItem?.dataId))
          ?.reduce((sum: number, gItem: any) => sum + (gItem?.value || 0), 0)
          .toFixed(2)
      );

      return {
        ...dataItem,
        value: totalValue
      };
    });

    return {
      ...item,
      data
    };
  });

  return {
    allChart,
    GHG,
    SCOPE
  };
};
